enum Colours {
    PINK_INFO_BACKGROUND = "#FCE6E7",
  }
  
  export default Colours;
  